/** Normalize company name: remove diacritics, uppercase, trim */
export function normalizeCompany(name) {
  if (!name) return "";
  return name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .trim();
}

const LS_KEY = "povinnosti_companies";

export function loadCompanyList() {
  try {
    const stored = localStorage.getItem(LS_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export function saveCompanyList(list) {
  localStorage.setItem(LS_KEY, JSON.stringify(list));
}

/** Merge and deduplicate two arrays of normalized company names, sorted */
export function mergeCompanyLists(listA, listB) {
  return [...new Set([...listA, ...listB])].sort();
}

// --- ZOZNAM POVINNOSTÍ ---

/** Normalize task name: trim, lowercase first letter kept, trim whitespace */
export function normalizeTaskName(name) {
  if (!name) return "";
  return name.trim();
}

const TS_KEY = "povinnosti_tasks";

export function loadTaskList() {
  try {
    const stored = localStorage.getItem(TS_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

export function saveTaskList(list) {
  localStorage.setItem(TS_KEY, JSON.stringify(list));
}

/** Merge and deduplicate two arrays of task names, sorted */
export function mergeTaskLists(listA, listB) {
  return [...new Set([...listA, ...listB])].sort((a, b) => a.localeCompare(b, "sk"));
}
